import { createElement, Fragment, ReactChild } from 'react';

type Props = {
  text: string;
  children?: (line: string, key: string) => ReactChild;
};

const DEFAULT_CHILDREN = (line: string, key: string) => <span key={key}>{line}</span>;

const LfToBr = ({ text, children = DEFAULT_CHILDREN }: Props) => (
  <Fragment>
    {text
      .split('\n')
      .reduce(
        (arr, line, i) =>
          i === 0
            ? [...arr, children(line, `line-${i}`)]
            : [...arr, <br key={`br-${i}`} />, children(line, `line-${i}`)],
        [] as ReactChild[],
      )}
  </Fragment>
);

export default LfToBr;
